export default __webpack_public_path__ + "static/media/view-shoop.ae020147.svg";